import { cloneLandingDefaults } from './defaultLandingContent';

export function parseLandingContent(raw) {
  const defaults = cloneLandingDefaults();

  if (!raw) return defaults;

  const parsed = typeof raw === 'string' ? (() => {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  })() : raw;

  if (!parsed || typeof parsed !== 'object') return defaults;

  return {
    ...defaults,
    ...parsed,
    hero_points: Array.isArray(parsed?.hero_points) ? parsed.hero_points : defaults.hero_points,
    overview_sections: Array.isArray(parsed?.overview_sections) ? parsed.overview_sections : defaults.overview_sections,
    comparison: Array.isArray(parsed?.comparison) ? parsed.comparison : defaults.comparison,
    faq: Array.isArray(parsed?.faq) ? parsed.faq : defaults.faq,
    final_cta: parsed?.final_cta || defaults.final_cta,
  };
}
